import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {connectI18n} from '../../connects';
import UserProfile from '../UserProfile';
import WaitWhileBusy from '../../WaitWhileBusy';
import connectUserId from './common/connectUserId';
import ValidateConnectionExists from './common/ValidateConnectionExists';

const ContactProfileConnected = compose(
    connectI18n,
    connectUserId
)(UserProfile);

export default props => (
    <WaitWhileBusy>
        <ValidateConnectionExists {...props}>
            <ContactProfileConnected {...props.match.params} />
        </ValidateConnectionExists>
    </WaitWhileBusy>
);
